import ContentStatusBadge from 'components/badge/ContentStatusBadge';
import ContentTypeBadge from 'components/badge/ContentTypeBadge';
import { DivConst } from 'constants/divConst';

import type { ContentSearchItemType } from 'types/api/contentSearchResponseType';
import { formatTimeToDate, getContentImageUrl } from 'utils/app';
import { openLineProductionUrl, openProductionUrl } from 'utils/content';
import WsContentSearchPagination from './WsContentSearchPagination';

import type { JSX } from 'react';

export interface WsContentSearchTableProps {
  contents: ContentSearchItemType[];
  pageNo: number;
  hasNext: boolean;
  onEdit: (content: ContentSearchItemType) => void;
  onReport: (content: ContentSearchItemType) => void;
  onCopy: (content: ContentSearchItemType) => void;
  onPrev: () => void;
  onNext: () => void;
}

/**
 * コンテンツ画面 一覧テーブルコンポーネント
 */
export default function WsContentSearchTable({
  contents,
  pageNo,
  hasNext,
  onEdit,
  onReport,
  onCopy,
  onPrev,
  onNext,
}: WsContentSearchTableProps): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <section className="section-report">
      <div className="container">
        <div className="box-common box-common-lg">
          <div className="table-responsive js-scrollable">
            <table
              className="table table-top-gray table-top-gray-list contents"
              style={{ minWidth: 'auto' }}
            >
              <thead>
                <tr>
                  <th className="col-1 w-224">コンテンツタイトル</th>
                  <th className="col-2">
                    日付
                    <span>▲</span>
                  </th>
                  <th className="col-4" style={{ width: '250px' }}></th>
                </tr>
              </thead>
              <tbody>
                {contents.map(content => {
                  return (
                    <tr key={`ws-quiz-search-${content.cd}`}>
                      <th>
                        <div className="d-flex d-flex-table">
                          {/* コンテンツ画像の表示 */}
                          <div className="flex-shrink-0 flex-img">
                            <img src={getContentImageUrl(content.imageKey)} className="img-fluid" />
                          </div>
                          {/* コンテンツタイトルの表示 */}
                          <div className="flex-grow-1 flex-text justify-content-start">
                            <a
                              onClick={() => onEdit(content)}
                              className="detail hover quiz-title mb-1"
                            >
                              {content.title}
                            </a>
                            <span>
                              <ContentTypeBadge contentsTypeDiv={content.contentsTypeDiv} />
                            </span>
                          </div>
                        </div>
                      </th>
                      <td>
                        {/* 登録日時の表示 */}
                        <p className="date-time mb-1">
                          {formatTimeToDate(content.createdAt, 'yyyy年M月dd日 h:mm a')}
                        </p>
                        {/* コンテンツステータスの表示 */}
                        <ContentStatusBadge
                          statusDiv={content.statusDiv}
                          contentsTypeDiv={content.contentsTypeDiv}
                        />
                      </td>
                      <td>
                        <div className="d-flex">
                          <div className="flex-grow-1 item-button">
                            <ul className="list-unstyled mb-0">
                              <li>
                                <button
                                  onClick={() => onEdit(content)}
                                  className="btn btn-common btn-common-w110 outline-blue"
                                >
                                  詳細
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={() => onReport(content)}
                                  className="btn btn-common btn-common-w110 outline-blue"
                                  disabled={content.publishedAt == null}
                                >
                                  レポート
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={() => onCopy(content)}
                                  className="btn btn-common btn-common-w110 outline-blue"
                                >
                                  複製
                                </button>
                              </li>
                              <li>
                                <button
                                  onClick={() =>
                                    content.lineFlag
                                      ? openLineProductionUrl(
                                          content.lineCd,
                                          content.contentsTypeDiv
                                        )
                                      : openProductionUrl(content.cd, content.contentsTypeDiv)
                                  }
                                  className="btn btn-common btn-common-w110 outline-blue"
                                  disabled={
                                    content.statusDiv !== DivConst.items.quizStatus.published.value
                                  }
                                >
                                  公開URL
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <WsContentSearchPagination
            pageNo={pageNo}
            hasNext={hasNext}
            onPrev={onPrev}
            onNext={onNext}
          />
        </div>
      </div>
    </section>
  );
}
